import React from 'react';

import { useTier1ReturnAuthorizationsActivity_TabBarQuery } from 'generated/graphql';
import { tableUtil } from 'modules';



export interface IData {
  numPreAlertAcknowledged: number;
  numAwaitingTriageObservation: number;
  numAwaitingReturnDecision: number;
  numAwaitingQualityControl: number;
  numPrintLabel: number;
}

export function useQuery(storeId?: string, searchText?: string) {
  const tuple = useTier1ReturnAuthorizationsActivity_TabBarQuery({
    variables: {
      storeId,
      searchText: searchText ?? ''
    }
  });

  tableUtil.useRefetchOverInterval(tuple, 5000);

  return React.useMemo(
    () => {
      const data: IData = {
        numPreAlertAcknowledged: tuple.data?.preAlert.pageInfo.totalRows ?? 0,
        numAwaitingTriageObservation: tuple.data?.awaitingTriageObservation.pageInfo.totalRows ?? 0,
        numAwaitingReturnDecision: tuple.data?.awaitingTriage.pageInfo.totalRows ?? 0,
        numAwaitingQualityControl: tuple.data?.awaitingQualityControl.pageInfo.totalRows ?? 0,
        numPrintLabel: tuple.data?.readyForLabel.pageInfo.totalRows ?? 0
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
